import React, { useState } from 'react';
import { CheckIcon, StarIcon, PackageIcon, TrophyIcon } from 'lucide-react';
import { plans } from '../data/offer';
import { Reveal } from './ui/Reveal';
interface PricingSectionProps {
  id?: string;
  title: string;
  titleAccent?: string;
  subtitle?: string;
}
export function PricingSection({
  id = 'planes',
  title,
  titleAccent,
  subtitle
}: PricingSectionProps) {
  const [selectedId, setSelectedId] = useState(plans.find(p => p.featured)?.id ?? plans[0].id);
  const selected = plans.find(plan => plan.id === selectedId) ?? plans[0];
  return <section id={id} aria-labelledby={`${id}-title`} className="border-b border-line bg-surface/40" data-id="element-195" data-mp="1sbgghm5ccpef">
      <div className="mx-auto max-w-content px-5 pb-10 pt-7 sm:px-8" style={{
      paddingTop: "28px"
    }} data-id="element-196" data-mp="227t7gc9i4p5h">
        <div className="mx-auto max-w-2xl text-center" data-id="element-197" data-mp="2uytjuj0o334">
          <h2 id={`${id}-title`} className="text-lg font-medium uppercase leading-tight tracking-tight text-ivory" data-id="element-198" data-mp="2wjp9nh2hs2k">
            {title}
            {titleAccent && <span className="text-accent" data-id="element-199" data-mp="1mh6kkza8f25g"> {titleAccent}</span>}
          </h2>
          {subtitle && <p className="mt-3 text-sm text-muted sm:text-base" data-id="element-200" data-mp="1hq7zzni7nhwe">{subtitle}</p>}
        </div>

        <ul className="mt-8 grid gap-5 lg:grid-cols-2" role="radiogroup" aria-label="Elegí tu MegaPack" style={{
        gap: "11px"
      }} data-id="element-201" data-mp="1cqv5qhp0f8js">
          {plans.map((plan, i) => {
          const Icon = plan.featured ? TrophyIcon : PackageIcon;
          const isSelected = plan.id === selectedId;
          return <Reveal key={plan.id} delay={i * 0.05} className="h-full" data-id="element-202" data-mp="20gpfurhy2j0c" data-mpi={i}>
                <li className="h-full" data-id="element-203" data-mp="20emr0asj2vx7">
                  <button type="button" role="radio" aria-checked={isSelected} onClick={() => setSelectedId(plan.id)} className={`flex h-full w-full flex-col rounded-2xl p-5 text-left transition-[border-color,background-color] duration-150 ease-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-ink sm:p-6 ${isSelected ? 'border-2 border-accent bg-surfaceAlt' : 'border border-line bg-surface hover:border-accent/50'}`} data-id="element-204" data-mp="1vgl9huar34nu">
                    <div className="flex w-full items-start justify-between gap-4" data-id="element-205" data-mp="mh4cl9dnfoli">
                      <div className="min-w-0" data-id="element-206" data-mp="7k3nldmue7qq">
                        <p className="flex items-center gap-2 text-[10px] font-black uppercase tracking-wide text-accent" data-id="element-207" data-mp="7jc3ayyp3wfr">
                          <Icon aria-hidden="true" className="h-4 w-4 shrink-0" data-id="element-208" data-mp="ckhtap0z15ll" />
                          {plan.featured ? 'MegaPack Reconexión + Método 12 Semanas' : 'MegaPack Reconexión'}
                        </p>
                        <p className="mt-1.5 text-[10px] leading-snug text-muted" data-id="element-209" data-mp="3kyqehc15yu3q">{plan.contents}</p>
                      </div>

                      <div className="shrink-0 text-right" data-id="element-210" data-mp="3pymj9dhoqpkc">
                        {plan.featured && <span className="mb-2 inline-flex items-center gap-1 rounded-md bg-accent px-2 py-0.5 text-[9px] font-black uppercase tracking-wide text-accentInk" data-id="element-211" data-mp="3bxa9xkx15m7f">
                            <StarIcon aria-hidden="true" className="h-2.5 w-2.5 fill-accentInk" data-id="element-212" data-mp="2xb3gf7f8t1m5" />
                            Más popular
                          </span>}
                        <p className="text-[10px] text-muted line-through" data-id="element-213" data-mp="2sdut6sf8m7e1">{plan.listPrice}</p>
                        <p className="text-[22px] font-bold leading-none tracking-tight text-ivory" data-id="element-214" data-mp="36d2vhu6p5vmg">
                          {plan.price}
                        </p>
                      </div>
                    </div>

                    <p className="mt-4 text-[10px] leading-snug text-muted" data-id="element-215" data-mp="3g7mhd9fw7j7m">
                      <span className="font-semibold text-ivory" data-id="element-216" data-mp="3bam9qu3ea8ee">Ideal para:</span> {plan.idealFor}
                    </p>

                    <p className={`mt-auto flex items-center gap-2 pt-5 text-[10px] font-black uppercase tracking-wide ${isSelected ? 'text-accent' : 'text-muted'}`} style={{
                  paddingTop: "14px"
                }} data-id="element-217" data-mp="3p43sico9bh3d">
                      <span className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full border ${isSelected ? 'border-accent bg-accent' : 'border-line'}`} data-id="element-218" data-mp="3u25asvduzcds">
                        {isSelected && <CheckIcon aria-hidden="true" className="h-2.5 w-2.5 text-accentInk" data-id="element-219" data-mp="lzfqh5ld3y5l" />}
                      </span>
                      {isSelected ? 'Seleccionado' : 'Seleccionar'}
                    </p>
                  </button>
                </li>
              </Reveal>;
        })}
        </ul>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-220" data-mp="3v54bq9po2xuh">
          <a href={selected.checkoutUrl} className="cta-breathe block w-full rounded-xl bg-accent px-4 py-4 text-center text-sm font-extrabold uppercase tracking-tight text-accentInk transition-[background-color] duration-150 ease-soft hover:bg-[#ffbd53]" style={{
          paddingTop: "10px",
          paddingBottom: "10px"
        }} data-id="element-221" data-mp="3v6fec67dlzk0">
            {selected.cta}
          </a>
          
        </div>
      </div>
    </section>;
}